// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mfe/" + chunkId + "." + {"56":"14cf1248854164828dce","61":"c677822cf3f57286c3d4","545":"2a9db5afa42aaf77ce2c","664":"9672edc6184d3e30a670","749":"323cb1a84c7f637c6465","778":"171a3a21af56f9a8f1f5","952":"2ef46bd2ecc4399f66ac"}[chunkId] + ".chunk.js";
};